<template>
	<div class=" p-3 border-15 shadow bg-white text-center" style="
		display: flex;
		align-items: center;
		justify-content: center;
		align-content: center;
		">
		<div style="width: 80%; z-index: 0;">
			<multi_step_progress :completed="page" :stepper_array="stepper_array" :stepper_warning="stepper_warning"
				:stepper_danger="stepper_danger" @click="(e) => { page = e }" />
			<!-- ____________________________________________________________________ -->
			<div v-if="page == 0">
				<div class="w-100 overflow-hidden">
					<div class="col-lg-4 col-md-4 col-sm-12 col-xs-12 float-right"
						:class="(windowWidth > 770) ? 'pr-0' : 'p-0'" 
						v-if="val_data.ok"
						>
						<textInput 
						label="تلفن‌همراه" 
						type="number"
						textClass="text-left"
						input_style="background-size: 16px; background-position: 95% center;" 
						:val="val.p1" 
						@inputTxtFunc="(e) => { val.p1 = e }" 
						:disabled="$localStorage.get('user').username.teacher_cheack.phone != 0" 
						:valid="valid.phone" 
						/>
					</div>
					<div class="col-lg-2 col-md-2 col-sm-12 col-xs-12 float-right"
						:class="(windowWidth > 770) ? 'pl-0' : 'p-0'">
						<btn style="margin-top: 33px;" @clickMe="check_phone()" class="w-100" textClass="w-100"
							:text="(val_btn.p1 == 0) ? '	تایید ' : minutes2time(val_btn.time_p1)" :disable="val_btn.p1"
							v-if="$localStorage.get('user').username.teacher_cheack.phone == 0" />

					</div>
					<div class="col-1 float-right">&nbsp;</div>
					<div class="col-lg-2 col-md-2 col-sm-12 col-xs-12 float-right "
						:class="(windowWidth > 770) ? 'pl-0' : 'p-0'">
						<textInput :val="val.p1_code" label="کد اعتبار سنجی" @inputTxtFunc="(e) => { val.p1_code = e }"
							type="number" placeholder=" "
							v-if="$localStorage.get('user').username.teacher_cheack.phone == 0" />
					</div>
					<div class="col-lg-2 col-md-2 col-sm-12 col-xs-12 float-right float-right"
						:class="(windowWidth > 770) ? 'pl-0' : 'p-0'">
						<btn 
							@clickMe="check_phone_code()" 
							style="margin-top: 33px;" 
							class="w-100" 
							textClass="w-100"
							text="ارسال" 
							v-if="$localStorage.get('user').username.teacher_cheack.phone == 0"
						/>
					</div>
				</div>
				<!-- ----------------------------------------------------------------------- -->
				<div class="w-100 overflow-hidden">
					<div class="col-lg-4 col-md-4 col-sm-12 col-xs-12 float-right"
						:class="(windowWidth > 770) ? 'pr-0' : 'p-0'">
						<textInput :val="val.p2" label="تلفن همراه عمومی (در اختیار کاربران قرار می‌گیرد)"
							@inputTxtFunc="(e) => { val.p2 = e }" type="number"
							:disabled="$localStorage.get('user').username.teacher_cheack.public_phone != 0"
							textClass="text-left" input_style="background-size: 16px; background-position: 95% center;"
							:valid="valid.public_phone" />
					</div>
					<div class="col-lg-2 col-md-2 col-sm-12 col-xs-12 float-right"
						:class="(windowWidth > 770) ? 'pl-0' : 'p-0'">
						<btn style="margin-top: 33px;" @clickMe="check_phone2()" class="w-100" textClass="w-100"
							:text="(val_btn.p2 == 0) ? '	تایید ' : minutes2time(val_btn.time_p2)" :disable="val_btn.p2"
							v-if="$localStorage.get('user').username.teacher_cheack.public_phone == 0" />

					</div>
					<div class="col-1 float-right">&nbsp;</div>
					<div class="col-lg-2 col-md-2 col-sm-12 col-xs-12 float-right "
						:class="(windowWidth > 770) ? 'pl-0' : 'p-0'">
						<textInput :val="val.p2_code" label="کد اعتبار سنجی" @inputTxtFunc="(e) => { val.p2_code = e }"
							type="number" placeholder=" "
							v-if="$localStorage.get('user').username.teacher_cheack.public_phone == 0" />
					</div>
					<div class="col-lg-2 col-md-2 col-sm-12 col-xs-12 float-right float-right"
						:class="(windowWidth > 770) ? 'pl-0' : 'p-0'">
						<btn @clickMe="check_phone2_code()" style="margin-top: 33px;" class="w-100" textClass="w-100"
							text="ارسال" v-if="$localStorage.get('user').username.teacher_cheack.public_phone == 0" />
					</div>
				</div>
			</div>
			<!-- ******************************************************************************* -->
			<div v-if="page == 1">
				<previewImage :img="val_data.data.img.val" :error="false" @chengeFile="(e) => { i = e; upload_user_pic() }" />
				<div class="w-100 overflow-hidden">
					<div class="col-lg-3 col-md-3 col-sm-12 col-xs-12 float-right"
						:class="(windowWidth > 770) ? 'pr-0' : 'p-0'">
						<textInput :val="val_data.data.fullname.val" label="نام و نام خانوادگی"
							@inputTxtFunc="(e) => { val_data.data.fullname.val = e }" />
					</div>
					<div class="col-lg-3 col-md-3 col-sm-12 col-xs-12 float-right"
						:class="(windowWidth > 770) ? 'pl-0' : 'p-0'">
						<textInput textClass="text-left" dir="ltr" type="number" :val="val_data.data.pid.val" label="کدملی"
							@inputTxtFunc="(e) => { val_data.data.pid.val = e }" />
					</div>
					<div class="col-lg-6 col-md-6 col-sm-12 col-xs-12 float-right"
						:class="(windowWidth > 770) ? 'pl-0' : 'p-0'">
						<uploadFile label="تصویر کارت ملی" :files="val_data.data.files.val.f1" :inputFile="val.file"
							@chengeFile="(e) => { val.file = e; uploadTF('f1'); }"
							@removeFile="(e) => { val_data.data.files.val.f1 = e; }" :error="false" error_text="" style="" />
					</div>
				</div>
				<div class="w-100 overflow-hidden">
					<div class="col-lg-6 col-md-6 col-sm-12 col-xs-12 float-right p-0">
						<textareaInput :value="val_data.data.address_teach.val"
							@inputTxtFunc="(e) => { val_data.data.address_teach.val = e }" label="آدرس" :error="false" />
					</div>

					<div class="col-lg-4 col-md-4 col-sm-12 col-xs-12 float-right"
						:class="(windowWidth > 770) ? 'pl-0' : 'p-0'">
						<textInput :val="val_data.data.postal_code.val" label="کدپستی"
							@inputTxtFunc="(e) => { val_data.data.postal_code.val = e }" />
					</div>
				</div>
				<div class="col-12" style="padding-top: 1rem;">
					<label id="label_map" class="pointer" style="
						transition: 0.3s;
						color: #000000;
						">
						<input type="checkbox" v-model="map"
							@click="(e) => { val_data.data.pic_location.val = []; val_data.data.location.val = null; }">
						مایل هستم علاوه بر تدریس در محل کاربر، در آدرس بالا تدریس انجام دهم.
					</label>
				</div>
				<div class="w-100 overflow-hidden" v-if="map">
					<div class="col-lg-6 col-md-6 col-sm-12 col-xs-12 float-right p-0">
						<mapComponent :lat_lng="val_data.data.location.val"
							@lat_lngFunc="(e) => { val_data.data.location.val = e }" />
					</div>

					<div class="col-lg-4 col-md-4 col-sm-12 col-xs-12 float-right"
						:class="(windowWidth > 770) ? 'pl-0' : 'p-0'">
						<uploadFile label="بارگزاری تصاویر محل تدریس" :files="val_data.data.pic_location.val"
							:inputFile="val.file" @chengeFile="(e) => { val.file = e; uploadTF('pic_location'); }"
							@removeFile="(e) => { val_data.data.pic_location.val = e; }" :error="false" error_text=""
							style="" />
					</div>
				</div>
			</div>
			<!-- ******************************************************************************* -->
			<div v-if="page == 2">
				<div class="w-100 overflow-hidden">
					<div class="col-lg-6 col-md-6 col-sm-12 col-xs-12 float-right p-0">
						<textareaInput :value="val_data.data.about_me.val"
							@inputTxtFunc="(e) => { val_data.data.about_me.val = e }" label="درباره من" :error="false"
							error_text="توضیحاتی را در باره خود وارد نمایید" />
					</div>

					<div class="col-lg-4 col-md-4 col-sm-12 col-xs-12 float-right"
						:class="(windowWidth > 770) ? 'pl-0' : 'p-0'">
						<uploadFile label="بارگزاری ویدئو نمونه تدریس" :files="val_data.data.video.val"
							:inputFile="val.file" @chengeFile="(e) => { val.file = e; uploadTF('video'); }"
							@removeFile="(e) => { val_data.data.video.val = e; }" :error="false" error_text="" style=""
							accept="video/mp4" />
					</div>
				</div>
				<div class="w-100 overflow-hidden">
					<div class="col-lg-6 col-md-6 col-sm-12 col-xs-12 float-right p-0">
						<textareaInput :value="val_data.data.documents.val"
							@inputTxtFunc="(e) => { val_data.data.documents.val = e }"
							label="مدارک تحصیلی (این مدارک به کاربران نمایش داده نمی شود)" :error="false" />
					</div>

					<div class="col-lg-4 col-md-4 col-sm-12 col-xs-12 float-right"
						:class="(windowWidth > 770) ? 'pl-0' : 'p-0'">
						<uploadFile label="بارگزاری مدارک تحصیلی" :files="val_data.data.pic_documents.val"
							:inputFile="val.file" @chengeFile="(e) => { val.file = e; uploadTF('pic_documents'); }"
							@removeFile="(e) => { val_data.data.pic_documents.val = e; }" :error="false" error_text=""
							style="" />
					</div>
				</div>
				<div class="w-100 overflow-hidden">
					<div class="col-lg-6 col-md-6 col-sm-12 col-xs-12 float-right p-0">
						<textareaInput :value="val_data.data.certificate.val"
							@inputTxtFunc="(e) => { val_data.data.certificate.val = e }"
							label="گواهینامه ها، افتخارات و جوایز (این مدارک به کاربران نمایش داده می شود)"
							:error="false" />
					</div>

					<div class="col-lg-5 col-md-5 col-sm-12 col-xs-12 float-right"
						:class="(windowWidth > 770) ? 'pl-0' : 'p-0'">
						<uploadFile label="بارگزاری گواهینامه ها، افتخارات و جوایز" :files="val_data.data.files.val.f2"
							:inputFile="val.file" @chengeFile="(e) => { val.file = e; uploadTF('f2'); }"
							@removeFile="(e) => { val_data.data.files.val.f2 = e; }" :error="false" error_text="" style="" />
					</div>
				</div>
			</div>
			<!-- ******************************************************************************* -->
			<div v-if="page == 4">
				<p style="color:#676767;">
					نتیجه ارزیابی

				</p>
				<btn type="orange" :img="require('../../assets/img/hourglass.svg')" style="margin-top: 33px;"
					text="در دست بررسی" v-if="val_data.data.status.val == 1" />
				<btn type="secondary" :img="require('../../assets/img/Edit_white.svg')" style="margin-top: 33px;"
					text="ویرایش مدارک" v-else-if="val_data.data.status.val == 2" @clickMe="() => { page = 1 }" />
				<btn type="success" :img="require('../../assets/img/tick_white.svg')" style="margin-top: 33px;"
					text="تایید شد" v-else-if="val_data.data.status.val == 3" />
				<btn type="danger" :img="require('../../assets/img/x_white.svg')" style="margin-top: 33px;" text=""
					v-else-if="val_data.data.status.val == 4" />
				<p class="mt-4" v-if="val_data.data.status.val == 1">
					پروفایل شما توسط کارشناسان ما در حال بررسی است. از شکیبایی شما متشکریم.
				</p>


				<!-- ------------------------------------------------------------------------- -->
				<div class="w-100 overflow-hidden mt-3" v-if="val_data.data.status.val == 3">
					<!-- ---------------------------------------------سطح کاربر---------------------------------------------- -->
					<div class="col-lg-3 col-md-3 col-sm-12 col-xs-12 float-right"
						:class="(windowWidth > 770) ? 'pr-0' : 'p-0'">
						<div class=" border border-15 text-center p-3" style="background-color:#FFFCF7; font-size: 12px;">
							سطح شما
							<p class="font-weight-bold text-center" style="font-size: 16px;">
								سطح
								{{ val_data.data.level.val }}
							</p>
							<img :src="require('../../assets/img/level_' + val_data.data.level.val + '.svg')" width="50" />
						</div>
					</div>
					<!-- ---------------------------------------------زمان کلاس---------------------------------------------- -->
					<div class="col-lg-3 col-md-3 col-sm-12 col-xs-12 float-right p-0">
						<div class=" border border-15 text-center p-3" style="background-color:#FFFCF7; font-size: 12px;">
							مدت زمان هر جلسه
							<p class="font-weight-bold text-center" style="font-size: 16px;">
								{{ ["", "30", "45", "60", "90"][val_data.data.time_class.val] }}
								دقیقه
							</p>
							<img :src="require('../../assets/img/time_class.svg')" width="50" />
						</div>
					</div>
					<!-- ---------------------------------------------قیمت کلاس---------------------------------------------- -->
					<div class="col-lg-3 col-md-3 col-sm-12 col-xs-12 float-right pl-0">
						<div class=" border border-15 text-center p-3" style="background-color:#FFFCF7; font-size: 12px;">
							حداکثر قیمت هر جلسه
							<p class="font-weight-bold text-center" style="font-size: 16px;">
								{{ ["", "300", "400", "500", "600"][val_data.data.price_class.val] }}
								تومان
							</p>
							<img :src="require('../../assets/img/price_class.svg')" width="50" />
						</div>
					</div>
					<!-- ---------------------------------------------پورسانت---------------------------------------------- -->
					<div class="col-lg-3 col-md-3 col-sm-12 col-xs-12 float-right"
						:class="(windowWidth > 770) ? 'pl-0' : 'p-0'">
						<div class=" border border-15 text-center p-3" style="background-color:#FFFCF7; font-size: 12px;">
							پورسانت هر جلسه
							<p class="font-weight-bold text-center" style="font-size: 16px;">
								{{ ["", "10", "20", "30", "40"][val_data.data.commission.val] }}
								درصد
							</p>
							<img :src="require('../../assets/img/commission.svg')" width="50" />
						</div>
					</div>
				</div>
				<!-- ------------------------------------------------------------------------- -->
				<div v-if="val_data.data.status.val == 2 || val_data.data.status.val == 4">
					<p class="mt-4" v-if="val_data.data.status.val == 4">
						دوست عزیز پروفایل شما توسط کارشناسان ما رد شد.
						<br />
						در صورت تمایل برای پیگیری و بازنگری مجدد مدارک از طریق تماس با پشتیبان میتوانید اقدام کنید.
					</p>
					<textareaInput label="توضیحات" :value="val_data.data.comment.val" :disabled="true" />
				</div>




			</div>


			<btn @clickMe="setPage();" textClass="float-left" style="margin-top: 33px;"
				:text="(page == 2) ? 'ارسال' : 'مرحله بعد'"
				v-if="page < 3 && $localStorage.get('user').username.teacher_cheack.phone != 0 && $localStorage.get('user').username.teacher_cheack.public_phone != 0" />






			<!-- ******************************************************************************* -->
			<div class="text-center" v-if="please_wait">
				لطفا صبر کنید
				<br>
				به زودی با شما تماس می‌گیرند
			</div>
			<!-- ******************************************************************************* -->
			<br />
			<br />
		</div>
	</div>
</template>

<script>
import multi_step_progress from "./multi_step_progress.vue";
import btn from "../../UI/button/btn.vue";
import textInput from "../../UI/input/textInput.vue";
import datepicker from "../../UI/input/datepicker.vue";
import multiSelectInput from "../../UI/input/multiSelectInput.vue";
import selectInput from "../../UI/input/selectInput.vue";
import textareaInput from "../../UI/input/textareaInput.vue";
import userImg from "../../UI/userImg/userImg.vue";
import pageNavigation from "../../UI/pageNavigation/pageNavigation.vue";
import previewImage from "../../UI/uploadFile/previewImage.vue";
import uploadFile from "../../UI/uploadFile/file_cloud.vue";
import mapComponent from "../../UI/map/map.vue";
import { loading, success, success_sm, error } from "../../assets/library/messege.js";
import { validateEmail, validatePhone } from "../../assets/library/filter.js";
import { time2minutes, minutes2time, classTime, timeOptions, vlaTimeOptions } from "../../assets/library/convertTime.js";

export default {
	name: 'profile_part1',
	data() {
		return {
			page: 0,
			map: false,
			imgurl: window.imgurl,
			baseurl: window.baseurl,
			success: success,
			success_sm: success_sm,
			error: error,
			loading: loading,
			validateEmail: validateEmail,
			validatePhone: validatePhone,
			time2minutes: time2minutes,
			minutes2time: minutes2time,
			classTime: classTime,
			timeOptions: timeOptions,
			vlaTimeOptions: vlaTimeOptions,
			stepper_array: [
				"احراز هویت",
				"بارگزاری اطلاعات تکمیلی",
				"مدارک و افتخارات",
				"ارزیابی"
			],
			stepper_warning: [],
			stepper_danger: [],
			valid: {
				phone: -1,
				public_phone: -1,
			},
			val: {
				p1: this.$localStorage.get("user").username.mobile,
				p1_code: "",
				p2: this.$localStorage.get("user").username.public_phone,
				p2_code: "",
				e: "",
				i: null,
				fullname: '',
				pid: this.$localStorage.get("user").username.pid,
				file: null,
				fs: {
					f1: [],
					f2: [],
				},
			},
			val_data: {
				ok: false,
			},
			btn_disabled: true,
			please_wait: false,
			val_btn: {
				p1: '0',
				p2: "0",
				e: "0",
				time_p1: 120,
				time_p2: 120,
			},
		}
	},
	components: {
		btn,
		multi_step_progress,
		validateEmail,
		vlaTimeOptions,
		validatePhone,
		classTime,
		timeOptions,
		time2minutes,
		uploadFile,
		minutes2time,
		datepicker,
		mapComponent,
		textInput,
		selectInput,
		pageNavigation,
		userImg,
		previewImage,
		textareaInput,
		multiSelectInput,
	},
	props: {

	},
	mounted() {
		this.loader();
	},
	methods: {
		upload_user_pic(THIS = this) {
			THIS.loading(THIS);
			var formData = new FormData();
			formData.append("file", this.i[0]);
			formData.append("format", ["jpg", "jpeg", "png", "pdf"]);
			formData.append("idImg", "t_" + THIS.$localStorage.get("user").username.id);
			var xhttp = new XMLHttpRequest();
			xhttp.open("POST", window.upldurl, true);
			xhttp.onreadystatechange = function () {
				if (this.readyState == 4 && this.status == 200) {
					this.getVar = JSON.parse(this.responseText);
					if (this.getVar.response == 1) {
						THIS.success_sm(THIS);
					} else {
						THIS.error(THIS, "فرمت فایل باید jpg باشد");
					}
				}
			};
			xhttp.send(formData);
		},
		//*********************************************************************
		setPage() {
			if (this.page == 2) {
				let usr = this.$localStorage.get('user');
				usr.porfile = 1;
				this.$localStorage.set('user', usr);
				delete this.val_data.data.phone;
				delete this.val_data.data.public_phone;
				delete this.val_data.data.img;
				this.val_data.data.status.val = 1;
				this.sav();
			}
			if (this.page < 2) {
				this.page = this.page + 1;
				if (this.val_data.data.pic_location.val.length > 0 || this.val_data.data.location.val.length > 0) {
					this.map = true;
				}
			}
		},
		// *********************************************************************
		sav(THIS = this) {
			document.body.scrollTop = 0;
			THIS.loading(THIS);
			window.$.post(this.baseurl + 'teachers/get_check_parameter', {
				token: this.$localStorage.get("user"),
				val_data: this.val_data.data
			}, function (D) {
				THIS.success_sm(THIS);
				THIS.loader();
				THIS.please_wait = (D.data.about_me.id > 0);
			}, "json");
		},
		// *********************************************************************
		uploadTF(val, THIS = this) {
			THIS.loading(THIS);
			var formData = new FormData();
			formData.append("file", this.val.file[0]);
			var formatDocs = this.$localStorage.get('formatDocs');

			if (val == "video") {
				formatDocs = ["mp4"];
			}
			formData.append("format", formatDocs);
			formData.append("idImg", "t_[DATE]_[RANDOM]");
			var xhttp = new XMLHttpRequest();
			var upldurl = window.upldurl;
			xhttp.open("POST", window.upldurl, true);
			xhttp.onreadystatechange = function () {
				if (this.readyState == 4 && this.status == 200) {
					this.getVar = JSON.parse(this.responseText);
					if (this.getVar.response == 1) {
						let F = {
							fileName: this.getVar.filename,
							fileUpload: this.getVar.uploadFileName,
						};
						if (val == 'f1') {
							THIS.val_data.data.files.val.f1.push(F);
						} else if (val == 'f2') {
							THIS.val_data.data.files.val.f2.push(F);
						} else if (val == 'img') {

						} else {
							if (THIS.val_data.data[val].val == null || THIS.val_data.data[val].val == '') {
								THIS.val_data.data[val].val = [];
							}
							THIS.val_data.data[val].val.push(F);
						}
						THIS.success_sm(THIS);
					} else {
						THIS.error(THIS, "فرمت فایل باید jpg باشد");
					}
				}
			};
			xhttp.send(formData);
		},
		//______________________________________________________________________
		check_phone(THIS = this) {
			if (this.val.p1 == "") {
				THIS.error(THIS, 'شماره تماس وارد کنید');
			} else if (this.validatePhone(this.val.p1)) {
				this.check_user("phone", this.val.p1);
				this.val_btn.p1 = '1';
				this.timer_p1();
			} else {
				THIS.error(THIS, 'شماره تماس وارد شده صحیح نمی‌باشد');
			}
		},
		//______________________________________________________________________
		check_phone2(THIS = this) {
			if (this.val.p2 == "") {
				THIS.error(THIS, 'شماره تماس وارد کنید');
			} else if (this.validatePhone(this.val.p2)) {
				this.check_user("public_phone", this.val.p2);
				this.val_btn.p2 = '1';
				this.timer_p2();
			} else {
				THIS.error(THIS, 'شماره تماس وارد شده صحیح نمی‌باشد');
			}
		},
		//______________________________________________________________________
		check_user(knd = "", val = "", code = "", THIS = this) {
			if(THIS.btn_disabled){
				THIS.btn_disabled = false;
				window.$.post(THIS.baseurl + "teachers/check", { token: THIS.$localStorage.get("user"), knd: knd, val: val, code: code }, function (D) {
					THIS.btn_disabled = true;
					if (code != "" && D.data == 0) {
						THIS.valid[knd] = D.data;
						var error_text = "";
						if (knd == "phone") {
							error_text = "کد تایید شماره تلفن همراه اشتباه است";
						}
						if (knd == "public_phone") {
							error_text = "کد تایید شماره تلفن همراه عمومی اشتباه است";
						}
						THIS.error(THIS, error_text);
					} else if (code != "" && D.data == 1) {
						THIS.valid[knd] = D.data;
						THIS.success(THIS, 'شماره تلفن‌همراه با موفقیت تایید شد');
						var ueser_local = THIS.$localStorage.get("user");
						ueser_local.username.teacher_cheack[knd] = 1;
						THIS.$localStorage.set("user", ueser_local);
					}
				}, "json");

			}
		},
		//______________________________________________________________________
		check_phone_code(THIS = this) {
			if (this.val.p1_code != "") {
				this.check_user("phone", this.val.p1, this.val.p1_code);
			} else {
				THIS.error(THIS, 'کد تایید شماره تلفن‌همراه را وارد کنید');
			}
		},
		//______________________________________________________________________
		check_phone2_code(THIS = this) {
			if (this.val.p2_code != "") {
				this.check_user("public_phone", this.val.p2, this.val.p2_code);
			} else {
				THIS.error(THIS, 'کد تایید شماره تلفن‌همراه عمومی را وارد کنید');
			}
		},
		//______________________________________________________________________
		timer_p1(THIS = this) {
			if (THIS.val_btn.time_p1 > 0) {
				setTimeout(() => {
					THIS.val_btn.time_p1 -= 1
					THIS.timer_p1();
				}, 1000)
			} else {
				this.val_btn.p1 = 0;
				this.val_btn.time_p1 = 120;
				this.val.p1_code = "";
			}
		},
		//______________________________________________________________________
		timer_p2(THIS = this) {
			if (THIS.val_btn.time_p2 > 0) {
				setTimeout(() => {
					THIS.val_btn.time_p2 -= 1
					THIS.timer_p2();
				}, 1000)
			} else {
				this.val_btn.p2 = 0;
				this.val_btn.time_p2 = 120;
				this.val.p2_code = "";
			}
		},
		//______________________________________________________________________
		multi_step_progress_lvl(THIS = this) {
			var num = 0;
			if (THIS.$localStorage.get("user").username.teacher_cheack.phone == 1 && THIS.$localStorage.get("user").username.teacher_cheack.public_phone == 1) {
				num = 1;
			}
			return num;
		},
		// *********************************************************************
		loader(THIS = this) {
			this.loading(this);
			document.body.scrollTop = 0;
			window.$.post(this.baseurl + 'teachers/get_check_parameter', {
				token: this.$localStorage.get("user"),
			}, function (D) {
				if(D.data.files.val==null){
					D.data.files.val = {f1 :[], f2: []};
				}
				THIS.val_data = D;
				THIS.success_sm(THIS);
				var user = THIS.$localStorage.get('user');
				user.username.teacher_cheack.phone = THIS.val_data.data.phone.act;
				user.username.teacher_cheack.public_phone = THIS.val_data.data.phone.act;
				THIS.$localStorage.set('user', user);
				// در انتظار تایید
				if(THIS.val_data.data.status.val == 1 && THIS.val_data.data.status.id != 0){
					THIS.page = THIS.stepper_array.length;
					THIS.stepper_warning = [THIS.page-1];
				}
				// در نقص مدارک
				if(THIS.val_data.data.status.val==2 && THIS.val_data.data.status.id>0){
					THIS.page = THIS.stepper_array.length;
					THIS.stepper_danger = [THIS.page-1, THIS.page-2, THIS.page-3 ];
				}
				// رد شده
				if(THIS.val_data.data.status.val==4 && THIS.val_data.data.status.id>0){
					THIS.page = THIS.stepper_array.length;
					THIS.stepper_danger = [THIS.page-1, THIS.page-2, THIS.page-3 ];
				}
				// تایید شده
				if(THIS.val_data.data.status.val==3 && THIS.val_data.data.status.id>0){
					THIS.page = THIS.stepper_array.length;
				}
			}, "json");
		},
		//______________________________________________________________________
	}
}
</script>
<style>
#label_map:hover {
	color: #ff6839 !important;
}
</style>
